import CookieConsent from "react-cookie-consent";
import gifwaves from "../../resources/images/scope.gif";
import { cookie } from "../../Data/siteContent";

const CookieConsentBlock = ({ isMobile, onAccept, onDecline }) => {
  const btnClass = isMobile ? "cookie-btn-mobile" : "cookie-btn-desktop";
  const popupClass = isMobile ? "cookie-popup" : "cookie-popup cookie-popup-desktop";

  return (
    <CookieConsent
      containerClasses={popupClass}
      location="bottom"
      buttonText={cookie.accept}
      declineButtonText={cookie.reject}
      enableDeclineButton
      disableButtonStyles
      contentStyle={{ flex: "none", margin: 0, width: "100%" }}
      onAccept={onAccept}
      onDecline={onDecline}
      buttonClasses={btnClass}
      declineButtonClasses={btnClass}
      expires={150}
    >
      <img src={gifwaves} alt="Wave animation" />
      <div>{cookie.message}</div>
    </CookieConsent>
  );
};

export default CookieConsentBlock;
